export default {
      id: "icon-garantie-usage",
      viewBox: "0 0 31 37",
      url: __webpack_public_path__ + "icons.svg#icon-garantie",
      toString: function () {
        return this.url;
      }
    }